import 'slick-carousel';
import 'youtube-background';

export async function DiagramCarousels() {
    $('.js-carousel').slick({
        arrows: true,
        dots: true,
        autoplay: false,
        mobileFirst: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        nextArrow: '<button class="slick-next fa fa-angle-right"></button>',
        prevArrow: '<button class="slick-prev fa fa-angle-left"></button>',
        rows: 0 // removes extra div and fixed missing content for 1.8.1
    });


    $('.js-scrolling-hero')
        .each(function () {
            var $carousel = $(this),
                $slides = $carousel.find('.js-scrolling-hero-slides'),
                $controlWrapper = $carousel.find('.scrolling-hero-controls'),
                themeClasses = ['theme-default', 'theme-light', 'theme-bright', 'theme-accent1', 'theme-accent2', 'theme-trinity', 'theme-classic']
                ;

            $slides
                .on('init afterChange', function ($slick) {
                    var classes = $($slick.target).find('.slick-active').attr('class').split(" ") || [];

                    for (var i = 0; i < classes.length; i++) {
                        if (classes[i].indexOf('theme-') !== -1) {
                            $controlWrapper.removeClass(themeClasses).addClass(classes[i]);
                        }
                    }
                })
                .slick({
                    adaptiveHeight: false,
                    appendDots: $carousel.find('.js-scrolling-hero-dots'),
                    autoplay: true,
                    autoplaySpeed: 5000,
                    dots: true,
                    fade: true,
                    slidesToScroll: 1,
                    slidesToShow: 1,
                    nextArrow: $carousel.find('.js-scrolling-hero-next'),
                    prevArrow: $carousel.find('.js-scrolling-hero-prev'),
                    rows: 0 // removes extra div and fixed missing content for 1.8.1
                });
        }
    );


    $('.js-synchronized-sliders').each(function () {
        var $container = $(this);
        var $slides = $container.find('.js-slides');
        var $thumbnails = $container.find('.js-thumbnails');

        if ($slides.find('.slide').length > 1) {
            $container.addClass('show-thumbs');

            $slides.slick({
                appendDots: $container.find('.js-scrolling-hero-dots'),
                arrows: true,
                autoplay: false,
                autoplaySpeed: 5000,
                dots: true,
                fade: true,
                nextArrow: $container.find('.js-synchronized-sliders-next'),
                prevArrow: $container.find('.js-synchronized-sliders-prev'),
                slidesToScroll: 1,
                slidesToShow: 1,
                rows: 0, // removes extra div and fixed missing content for 1.8.1
                asNavFor: $thumbnails
            });

            $thumbnails.slick({
                arrows: false,
                autoplay: false,
                centerMode: false,
                dots: false,
                fade: false,
                focusOnSelect: true,
                infinite: true,
                respondTo: 'min',
                slidesToShow: 6,
                slidesToScroll: 6,
                variableWidth: true,
                responsive: [
                    {
                        breakpoint: 1024,
                        settings: {
                            slidesToShow: 3,
                            slidesToScroll: 3
                        }
                    },
                    {
                        breakpoint: 600,
                        settings: {
                            slidesToShow: 2,
                            slidesToScroll: 2
                        }
                    },
                    {
                        breakpoint: 480,
                        settings: {
                            slidesToShow: 1,
                            slidesToScroll: 1
                        }
                    }
                ],
                asNavFor: $slides
            });

            //// pause on interactions that change the slide
            //$container.find('.js-thumbnails .slick-slide, .js-synchronized-sliders-next, .js-synchronized-sliders-prev').on('click', function () {
            //    $(this).closest('.js-synchronized-sliders').find('.js-slides').slick('slickPause');
            //})
            //$slides.on('swipe', function () {
            //    $(this).slick('slickPause');
            //})
        }
    });

    //Note: 1.0.10 of youtube-background is the last version of this plugin that supports IE11/ES5
    if (window.innerWidth > 1184) {
        $('.scrolling-hero-video > div[data-youtube]').youtube_background();
    }

    $('.js-listing-carousel').each(function () {
        var $carousel = $(this)
            , $slideWrapper = $carousel.find('.js-listing-carousel-slides')
            , $slides = $slideWrapper.find('.js-slide')

        $slideWrapper.slick({
            appendDots: $carousel.find('.js-carousel-pagination'),
            arrows: true,
            autoplay: false,
            centerMode: false,
            centerPadding: '2rem',
            dots: true,
            infinite: true,
            slides: $slides,
            slidesToShow: 4,
            swipeToSlide: true,
            respondTo: 'min',
            responsive: [
                {
                    breakpoint: 1024,
                    settings: {
                        centerPadding: '0',
                        slidesToShow: 3
                    }
                },
                {
                    breakpoint: 600,
                    settings: {
                        centerPadding: '0',
                        slidesToShow: 2
                    }
                },
                {
                    breakpoint: 470,
                    settings: {
                        centerPadding: '0',
                        slidesToShow: 1
                    }
                }
            ],
            nextArrow: $carousel.find('.js-content-listing-carousel-next'),
            prevArrow: $carousel.find('.js-content-listing-carousel-prev'),
            rows: 0 // removes extra div and fixed missing content for 1.8.1
        });
    });
}